import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'

const ConnectorInfo = ({ field, onClick }) => {
  const intl = useIntl();
  return field ? (
    <span className="connector-mapping-info-link" onClick={onClick}>
      {field}
    </span>
  ) : (
    <span className="connector-mapping-info-none">None</span>
  )
}

ConnectorInfo.propTypes = {
  field: PropTypes.string,
  onClick: PropTypes.func.isRequired,
}

export default ConnectorInfo
